import React from "react"
import ImageGallery from "react-image-gallery"

// Standard photo album, used on gallery page _and_ in portable text
const PhotoAlbum = ({ imageUrlArray = [], className = "" }) => {
  if (imageUrlArray.length) {
    return (
      <div className={`mt-5 mb-16 ${className} `}>
        <ImageGallery
          items={imageUrlArray}
          thumbnailPosition="bottom"
          showBullets="true"
        />
      </div>
    )
  }
  return null
}

export default PhotoAlbum
